import styled from 'styled-components';

export const Label = styled.label`
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  margin: 1.5rem 0;
  color: #fff;

  > span:first-child {
    color: #e04a66 !important;
    margin-top: 10px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.3;
  }
  > input {
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 4px;
    color: #dee2e6;
    background: #323a4e;
    padding: 15px 5px;
    padding-left: ${p => (p.icon ? '2.5rem' : '1.6rem')};
    transition: 180ms ease-in-out;
    display: flex;
    align-items: center;
    :focus {
      box-shadow: none;
      border-color: rgba(255, 255, 255, 0.1);
    }
    ~ svg {
      fill: #dee2e6;
      position: absolute;
      left: 1rem;
      top: 3rem;
      transition: default;
    }
    + span {
      font-weight: 700;
      margin-bottom: 0.8rem;
    }
  }
  > button {
    position: absolute;
    border: 0;
    background: none;
    padding: 0;
    right: 1rem;
    top: 2.8rem;
    z-index: 2;
    :hover {
      transform: scale(1.1);
    }
  }
`;
